"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registration = void 0;
var registration = function () {
    return {
        generateBaasSignupUrl: function (applicationId, hatName, email, redirect, newsLetterOptins) {
            return "https://hatters.dataswift.io/services/baas/signup?email=" + email + "&hat_name=" + hatName + "&application_id=" + applicationId + "&newsletter_optin=" + (newsLetterOptins !== null && newsLetterOptins !== void 0 ? newsLetterOptins : false) + "&redirect_uri=" + redirect;
        },
        generateDaasSignupUrl: function (applicationId, redirect, tags) {
            var url = "https://hatters.dataswift.io/services/daas/signup?application_id=" + applicationId + "&redirect_uri=" + redirect;
            if (tags && tags.length > 0) {
                url += "&tags=" + tags.join(',');
            }
            return url;
        },
    };
};
exports.registration = registration;
